import { NavLink } from "./components/NavItem/NavLink";
import PhoneNumber from "./components/PhoneNumber/PhoneNumber";
import { INavLinks } from "./type";
import { Logo } from "@silversea-ssc/ui-components-react";
import React, { FC } from "react";
import { INavigationLinks } from "src/urls/urls";
import { Language } from "src/utils/localization/languages/types";
import { legacyUrl } from "src/utils/routing/legacyUrl";
import * as styles from "./HeaderNavBarLight.module.scss";

const ServiceNavbar = ({ children }) => {
  return (
    <nav className={styles.serviceNavbar} aria-label="Service menu">
      <ul>
        {children.map((c, index) => (
          <li key={index}>{c}</li>
        ))}
      </ul>
    </nav>
  );
};

export interface HeaderNavBarProps {
  serviceLinks?: INavLinks;
  language: Language;
}

export const HeaderNavBarLight: FC<HeaderNavBarProps> = ({
  serviceLinks,
  language
}) => {
  return (
    <nav className={styles.header}>
      <div className={styles.headerContainer}>
        <div className={styles.brandLogo}>
          <a href={legacyUrl(`/${language.path}`)} style={{ display: "block" }}>
            <Logo />
          </a>
        </div>
        <ServiceNavbar>
          {serviceLinks &&
            serviceLinks.map((l) => (
              <NavLink
                key={l.href}
                link={l}
                variant="secondary"
                expandOnMobile={false}
                type={l.asButton ? "button" : undefined}
              />
            ))}
          <PhoneNumber />
        </ServiceNavbar>
      </div>
    </nav>
  );
};

export interface StaticHeaderNavBarLightProps {
  navigationLinks: INavigationLinks;
  language: Language;
}

export const StaticHeaderNavBarLight: React.FC<StaticHeaderNavBarLightProps> = ({
  language,
  navigationLinks
}) => {
  const serviceLinks = [
    {
      ...navigationLinks.serviceLinks.raq,
      id: "raq",
      ["data-content-piece"]: "request_a_quote",
      asButton: true
    },
    {
      ...navigationLinks.serviceLinks.brochures,
      id: "brochures",
      ["data-content-piece"]: "view_the_brochures"
    }
  ];

  return <HeaderNavBarLight serviceLinks={serviceLinks} language={language} />;
};
